"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Page_1 = require("./Page");
exports.default = Page_1.default;
exports.PageContext = Page_1.PageContext;
//# sourceMappingURL=index.js.map